module.exports = __webpack_public_path__ + "img/SAS_RedPaintedRoundShield.cc6b3e79.png";